// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"27a629c4c26ad58a2e74","263":"1921574fe5d915135a26","791":"380e80a9f9d68688b8a3"}[chunkId] + ".js";
};